import { Grid } from "@mui/material";

import GasInputForm from "../offices/GasInputForm";
import ElectricInputForm from "../offices/ElectricInputForm";

import {
  useElectricityInputProps,
  useGasInputProps,
} from "../../../helpers/components/inputs";

const CombinedUtilitiesInputBlock = ({
  fuelType,
  setFuelType,
  gasUnit,
  setGasUnit,
  electricKwh,
  setElectricKwh,
  gasUnitValue,
  setGasUnitValue,
  electricRenewablesAndIntensityInputFormProps,
  disabled,
}) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <ElectricInputForm
          electricKwh={electricKwh}
          setElectricKwh={setElectricKwh}
          {...electricRenewablesAndIntensityInputFormProps}
          disabled={disabled}
        />
      </Grid>
      <Grid item>
        <GasInputForm
          fuelType={fuelType}
          setFuelType={setFuelType}
          unitValue={gasUnitValue}
          setUnitValue={setGasUnitValue}
          gasUnit={gasUnit}
          setGasUnit={setGasUnit}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

const useCombinedUtilitiesInput = ({ transaction = {}, onSave }) => {
  const { status } = transaction;
  const {
    electricKwh,
    setElectricKwh,
    electricRenewablesAndIntensityInputFormProps,
    electricCarbonTons,
    saveEnabled: electricitySaveEnabled,
    saveObject: electricitySaveObject,
  } = useElectricityInputProps(transaction);

  const {
    gasCarbonTons,
    gasUnit,
    setGasUnit,
    gasUnitValue,
    setGasUnitValue,
    fuelType,
    setFuelType,
    saveEnabled: gasSaveEnabled,
    saveObject: gasSaveObject,
  } = useGasInputProps(transaction);

  const inputBlock = (
    <CombinedUtilitiesInputBlock
      fuelType={fuelType}
      setFuelType={setFuelType}
      gasUnit={gasUnit}
      setGasUnit={setGasUnit}
      gasUnitValue={gasUnitValue}
      setGasUnitValue={setGasUnitValue}
      electricKwh={electricKwh}
      setElectricKwh={setElectricKwh}
      electricRenewablesAndIntensityInputFormProps={
        electricRenewablesAndIntensityInputFormProps
      }
      disabled={status === "locked"}
    />
  );

  const tonsCo2e = electricCarbonTons + gasCarbonTons;

  const onTransactionSave = () => {
    onSave({
      electricCarbonTons,
      gasCarbonTons,
      tonsCo2e,
      emissionData: {
        ...electricitySaveObject.emissionData,
        ...gasSaveObject.emissionData,
      },
    });
  };

  const saveEnabled = gasSaveEnabled && electricitySaveEnabled;

  return {
    inputBlock,
    onTransactionSave,
    saveEnabled,
    tonsCo2e,
  };
};
export default useCombinedUtilitiesInput;
